module.exports = __webpack_public_path__ + "img/2.3a1f0bc8.jpg";